// 首页

export default {
    namespaced: true, // 开启命名空间
    state: () => {
      return {
        profile: {
          scrollTop:0
        }
      }
    },
    mutations: {
      setHome: (state, data) => {
        // 拼接对象
        if(data == 'clear'){
          // 清空
          state.profile = {}
        }else{
          Object.assign(state.profile,data)
        }
      }
    }
  
  }
  